import router from "../router";
import ROUTER_URL from "../constant/urls";
import Vue from "vue";
// import jwt_decode from "jwt-decode";

import { isAuthenticated } from "@/common/commonFunctions";
// console.log('isAuthenticated', !isAuthenticated);

// import html2canvas from "html2canvas";
export default {
  shareLink: (url, text, title, noTokenRedirect = true) => {
    let newUrl = new URL(url);
    console.log(!isAuthenticated);
    if (!isAuthenticated) {
      router.push({ name: "login" });
    } else if (noTokenRedirect) {
      // console.log('router to login');
      console.log(newUrl);
      navigator
        .share(
          {
            title: title,
            text: text,
            url: newUrl.href,
          },
          {
            skype: false,
            pinterest: false,
            print: false,
            sms: false,
          }
        )
        .then(() => console.log("Share successful"))
        .catch((error) => console.error("Share failed:", error));
    }
  },
  shareSsAndLink: (div, url, text, title) => {
    let newUrl = new URL(url);
    console.log(text, title, div, url);
    let fileDiv = document.getElementById(div);
    console.log(fileDiv);
    // var screenshot = null;
    // html2canvas(fileDiv).then((canvas) => {
    //   console.log(canvas, "canvas");
    //   canvas.toBlob((blob) => {
    //     screenshot = new File([blob], "image.jpeg", { type: "image/jpeg" });
    //     const data = {
    //       // files: [screenshot],
    //       title: title,
    //       text: text,
    //       url: newUrl.href,
    //     };
    //     // console.log(navigator.canShare(data),"canshare")
    //     navigator.share(data);
    //   });
    // });
    const data = {
      // files: [screenshot],
      title: title,
      text: text,
      url: newUrl.href,
    };
    // console.log(navigator.canShare(data),"canshare")
    navigator.share(data, {
      skype: false,
      pinterest: false,
      print: false,
      sms: false,
    });
  },
  sharePlaylist(user_id, ptid) {
    let base_url = `${location.protocol}//${location.host}`;
    let endpoint = `${ROUTER_URL.userPanel.children.playlistDetail.link}/?ptid=${ptid}&usid=${user_id}`;
    let url = base_url + endpoint;
    this.shareLink(url, " ", "");
  },
  shareVideo() {
    // console.log(location.href, "hrev");
    this.shareLink(location.href, "", "");
  },
  isSameUser: (user_id) => {
    let user = localStorage.getItem("user_id");
    if (parseInt(user_id) === parseInt(user)) {
      return true;
    } else {
      return false;
    }
  },
  goToProfile(user_id, name) {
    if (this.isSameUser(user_id)) {
      router.push({
        name: ROUTER_URL.userPanel.children.myProfile.name,
      });
    } else {
      router.push({
        name: "OthersProfilePage",
        params: {
          id: user_id,
          name: name,
        },
      });
    }
  },
  removeZerosInCrore(number) {
    number = number / 10000000;
    number = parseInt(number.toFixed(2)).toLocaleString("en-IN");
    return number;
  },
  caculate_figures(trade, security) {
    var up_down = security.live_price - security.close_price;
    var pl_price, pl_percent;
    if (security.close_price) {
      var profit_percent =
        ((security.live_price - security.close_price) / security.close_price) *
        100;
    }
    if (trade.status === "Inactive" && trade.trade_type === "Buy") {
      pl_price = (trade.target_price - trade.entry_price) * trade.lots;
      pl_percent =
        (((trade.target_price - trade.entry_price) * trade.lots) /
          (trade.entry_price * trade.lots)) *
        100;
    } else if (trade.status === "Active" && trade.trade_type == "Buy") {
      pl_price = (security.live_price - trade.entry_price) * trade.lots;
      pl_percent =
        (((security.live_price - trade.entry_price) * trade.lots) /
          (trade.entry_price * trade.lots)) *
        100;
    } else if (trade.status === "Inactive" && trade.trade_type === "Sell") {
      pl_price = (trade.entry_price - trade.target_price) * trade.lots;
      pl_percent =
        (((trade.entry_price - trade.target_price) * trade.lots) /
          (trade.entry_price * trade.lots)) *
        100;
    } else if (trade.status === "Active" && trade.trade_type == "Sell") {
      pl_price = (trade.entry_price - security.live_price) * trade.lots;
      pl_percent =
        (((trade.entry_price - security.live_price) * trade.lots) /
          (trade.entry_price * trade.lots)) *
        100;
    }

    if (trade.status === "Closed") {
      pl_price = trade.pl_data;
      pl_percent = trade.pl_percent;
    } else {
      pl_price = pl_price.toFixed(2);
      pl_percent = pl_percent.toFixed(2);
    }
    return {
      up_down: up_down ? up_down.toFixed(2) : up_down,
      profit_percent: profit_percent ? profit_percent.toFixed(2) : 0,
      pl_price: pl_price,
      pl_percent: pl_percent,
    };
  },
};
Vue.filter("compressLargeNumbers", (value) => {
  var val;
  if (value) {
    val = parseInt((value / 10000000).toFixed(2));
    val = val.toLocaleString("en-IN");
  } else {
    val = null;
  }
  return val;
});

Vue.filter("addCommasInNumber", (value) => {
  return value.toLocaleString("en-IN");
});

Vue.filter("addCommaAndDecimalPlace", (value) => {
  return value.toFixed(2);
});

Vue.filter("addCommaDecimal", (num) => {
  let n = String(num).split(".");
  let commaString = parseInt(n[0]).toLocaleString("en-IN");
  if (n.length > 1) {
    if (n[1].length == 1) {
      return `${commaString}.${parseInt(n[1])}0`;
    } else {
      return `${commaString}.${n[1].slice(0, 2)}`;
    }
  } else {
    return `${commaString}.00`;
  }
});
